import { render, staticRenderFns } from "./CreateSGClusters.vue?vue&type=template&id=afc3e8e0&scoped=true"
import script from "./CreateSGClusters.vue?vue&type=script&lang=js"
export * from "./CreateSGClusters.vue?vue&type=script&lang=js"
import style0 from "./CreateSGClusters.vue?vue&type=style&index=0&id=afc3e8e0&prod&scoped=true&lang=css"
import style1 from "./CreateSGClusters.vue?vue&type=style&index=1&id=afc3e8e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc3e8e0",
  null
  
)

export default component.exports